export const colour = {
  bg: '#FBF4E8',
  bgWarm: '#F5E8D2',
  bgDeep: '#14101A',
  card: '#FFFFFF',
  cardWarm: '#FFF8EB',
  ink: '#1A1410',
  inkSoft: '#3D3429',
  inkFaded: '#7A6F5F',
  inkGhost: '#B8AC97',
  tomato: '#E94D2C',
  tomatoDeep: '#B83518',
  peach: '#FFB088',
  peachSoft: '#FFD4B8',
  terracotta: '#C9572D',
  mustard: '#E8A33A',
  mustardSoft: '#F5C97A',
  rose: '#E94B6B',
  roseSoft: '#F8B6C2',
  sage: '#6B8C5E',
  sageDeep: '#4A6B3F',
  teal: '#1B5E62',
  tealSoft: '#4A8589',
  navy: '#1F2D44',
  plum: '#5B2A4A',
  lilac: '#B89FD4',
} as const;

export type ColourId = keyof typeof colour;

export const memberColours: Record<string, ColourId> = {
  stu: 'tomato',
  jomi: 'teal',
  siena: 'rose',
  will: 'sage',
  max: 'navy',
  shared: 'mustard',
};

export function colourFor(member: string): string {
  const key = memberColours[member.toLowerCase()] ?? 'mustard';
  return colour[key];
}
